export default {
	apiUrl: 'https://landlord-stage.rentalstep.co/index.php/',
};

const siteConfig = {
	siteName: 'RentalStep',
	siteIcon: 'ion-flash',
	footerText: '©2018 RentalStep',
	enableAnimatedRoute: false,
};

const stripeKeys = {
	live: 'pk_live_4kWVyyAgQqmuYU1ntmfwMpLm',
	test: 'pk_test_i6RABrtGw7vByBVuRMDVhGMN'
};

const stripeKey = process.env.NODE_ENV === 'production' ? stripeKeys.live : stripeKeys.test;


const themeConfig = {
	topbar: process.env.REACT_APP_THEME,
	sidebar: process.env.REACT_APP_THEME,
	layout: process.env.REACT_APP_THEME,
	theme: process.env.REACT_APP_THEME,
	breadCrumbTheme: process.env.REACT_APP_THEME,
	showBreadCrumb: true,
	fixedNavbar: true
};

const language = 'english';

const AlgoliaSearchConfig = {
	appId: '',
	apiKey: '',
};

const Auth0Config = {
	domain: '',
	clientID: '',
	audience: '',
	options: {
		auth: {
			autoParseHash: true,
			redirect: false,
		},
		languageDictionary: {
			title: 'Metaadmin',
			emailInputPlaceholder: 'demo@gmail.com',
			passwordInputPlaceholder: 'demodemo',
		},
		icon: '',
		theme: {
			labeledSubmitButton: true,
			logo: '',
			primaryColor: '#E14615',
			authButtons: {
				connectionName: {
					displayName: 'Log In',
					primaryColor: '#b7b7b7',
					foregroundColor: '#000000',
					icon: undefined,
				},
			},
		},
	},
};

const firebaseConfig = {
	apiKey: '',
	authDomain: '',
	databaseURL: '',
	projectId: '',
	storageBucket: '',
	messagingSenderId: '',
};

const googleConfig = {
	apiKey: 'AIzaSyCRbXTogeT5L2Yp-wwOuLzvZmlmZ3iGyu4', //
};

const mapboxConfig = {
	tileLayer: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
	maxZoom: 18,
	defaultZoom: 11,
	center: [0, 0],
};

const youtubeSearchApi = '';

const instagramConfig = {
	instagramUserInfoApiUrl:
		'https://api.instagram.com/v1/users/self/?access_token=',
	instagramUserMediaApiUrl:
		'https://api.instagram.com/v1/users/self/media/recent/?access_token=',
	accessToken: '',
};

const jwtConfig = {
	fetchUrl: '',
	secretKey: '',
};


const getEnvUrls = () => {
	const themeApiUrl = {};
  const isStage = (process.env.REACT_APP_ENV === "prod") ? "" : "-stage";
  switch (process.env.REACT_APP_THEME) {
		case "telford":
			themeApiUrl.authUrl = `telford-auth-landlord${isStage}`;
			themeApiUrl.apiUrl = `api-telford${isStage}`;
			break;
		default:
			themeApiUrl.authUrl = `auth-landlord${isStage}`;
			themeApiUrl.apiUrl = `api${isStage}`;
	}
	return themeApiUrl;
};

const getApiUrl = getEnvUrls();

const apiUrls = {
	login: `https://${getApiUrl.authUrl}.rentalstep.co/index.php/auth/login`,
	signup: `https://${getApiUrl.authUrl}.rentalstep.co/index.php/auth/signup`,
	confirmEmail: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/accountConfirm`,
	requestPasswordReset: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/noauth-api/landlordRequestPasswordReset`,
	changePasswordRequest: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/noauth-api/landlordChangePasswordRequest`,
	verifyActivation: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/noauth-api/landlord-verify-activation`,
	activatePassword: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/noauth-api/landlord-activate-password`,
	changePassword: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/landlordChangePassword`,
	updateExtendedProfile: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/updateExtendedProfile`,
	getUserProfile: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/getUserProfile`,
	getLandlordDashboard: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/landlordGetDashboard`,
	addProperty: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/addProperty`,
	listProperties: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/getPropertiesNew`,
	getProperty: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/getPropertyByHash`,
	getLandlordPropertySlotData: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/getLandlordPropertySlotData`,
	joinExcellenceProgramme: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/joinExcellenceProgramme`,
	getPropertyHmo: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/landlordGetPropertyHmoDetails`,
	getPropertyDetails: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/landlordGetPropertyDetails`,
	getPropertyRentalDetails: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/landlordGetPropertyRentalData`,
	updateProperty: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/updateProperty`,
	updatePropertyHmo: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/landlordUpdatePropertyHmoDetails`,
	updatePropertyDetails: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/landlordUpdatePropertyDetails`,
	updatePropertyRentalDetails: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/landlordUpdateRentalData`,
	getPropertyImages: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/landlordGetPropertyImagesByHash`,
	getPropertyListing: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/landlordGetPropertyDetailsByHash`,
	updatePropertyListing: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/createPropertyListing`,
	epcLookup: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/noauth-api/epcLookup`,
	hmoLookup: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/noauth-api/getHmoStatus`,
	inviteTenant: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/landlordInviteTenantReference`,
	addTenant: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/landlordInviteTenant`,
	listTenants: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/landlordGetInvitedTenants`,
	inviteTenant: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/landlordInviteTenantReference`,
	removeTenantInvite: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/remove-tenant-invite`,
	reorderImages: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/reorderImages`,
	propertyImageUpload: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/propertyImageUpload`,
	setImageDeleted: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/setImageDeleted`,
	getLandlordIssueReports: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/getLandlordIssueReports`,
	getIssueReport: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/getIssueReport`,
	landlordResolveIssue: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/landlordResolveIssue`,
	// getIssueReportImages: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/api/tenantGetIssueImages`,
	getPropertyPreferences: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/getPropertyPreferences`,
	getPropertyPreferencesSingle: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/getPropertyPreferencesSingle`,
	landlordSaveEntityPreferences: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/landlordSaveEntityPreferences`,
	addPropertyPreferenceSingle: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/addPropertyPreferenceSingle`,
	deletePropertyPreferenceSingle: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/deletePropertyPreferenceSingle`,
	landlordMakeStripePayment: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/landlordMakeStripePayment`,
	landlordMakeStripeSubscriptionPayment: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/startPropertySubscription`,
	landlordAddPropertyToPortalQueue: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/landlordAddPropertyToPortalQueue`,
	landlordRemovePropertyFromPortalQueue: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/landlordDeListPropertyOnRightmoveByRentalHash`,
	getListingPrice: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/noauth-api/getPrice`,
	landlordGetLandlordReference: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/noauth-api/landlordGetLandlordReference`,
	landlordUpdateLandlordReference: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/noauth-api/landlordUpdateLandlordReference`,
	addPropertyPreference: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/addPropertyPreference`,
	deletePropertyPreference: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/deletePropertyPreference`,
	createAstForLandlord: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/createAstForLandlord`,
	getAstForLandlord: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/getAstForLandlord`,
	updateTenancyAgreement: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/updateTenancyAgreement`,
	landlordGetOutstandingReferences: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/landlordGetOutstandingReferences`,
	landlordGetTenantReference: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/landlordGetTenantReference`,
	// getPropertyAstList: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/getPropertyAstList`,
	getAllAstList: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/getAllAstList`,
	landlordRemoveAst: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/landlordRemoveAst`,
	landlordSignTenancyAgreement: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/landlordSignTenancyAgreement`,
	getRentVerifyDetails: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/noauth-api/getRentVerifyDetails`,
	verifyPayment: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/noauth-api/verifyPayment`,
	declinePayment: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/noauth-api/declinePayment`,
	getLandlordAddressBook: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/getLandlordAddressBook`,
	getInboxV2: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/getInboxV2`,
	getBucketCounts: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/getBucketCounts`,
	sendReplyToThread: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/sendReplyToThread`,
	sendMessage: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/sendMessage`,
	sentMessages: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/getSentMessagesV2`,
	archiveThread: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/landlordAddThreadArchivingV2`,
	unArchiveThread: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/landlordRemoveThreadArchivingV2`,
	markThreadRead: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/landlordMarkThreadAsReadByUserV2`,
	getPropertyViewings: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/getLandlordPropertyViewingBookings`,
	confirmPropertyViewing: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/landlordConfirmPropertyViewing`,
	confirmRescheduledPropertyViewing: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/landlordRescheduleConfirm`,
	landlordRescheduleBooking: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/landlordRescheduleBooking`,
	landlordCancelBooking: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/landlordCancelViewingBooking`,
	getLandlordRentVerificationsBulk: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/noauth-api/getLandlordRentVerificationsBulk`,
	removePropertyRentalTenant: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/removeRentalTenant`,
	updateTenantRentalLink: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/updateTenantRentalLink`,
	addPropertyRentalTenant: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/addRentalTenant`,
	getPropertyRentalTenants: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/getPropertyRentalTenants?indexByTenantId=1`,
	updateRentalData: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/landlordUpdateRentalData`,
	getRentalData: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/landlordGetPropertyRentalData`,
	addRentalData: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/landlordAddRentalData`,
	setLandlordAddress: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/setLandlordAddress`,
	getLandlordAddress: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/getLandlordAddresses`,
	propertyDocumentUpload: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/propertyDocumentUpload`,
  propertyDocumentRemove: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/removePropertyDocument`,
	cancelPropertySubscription: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/landlordCancelPropertySubscription`,
	getEnquiryGraphAndData: `https://${getApiUrl.apiUrl}.rentalstep.co/app_dev.php/landlord-api/landlordPropertyEnquiryGraphAndData`,
};

const getaddressConfig = {
	API_KEY: "bYUpr6V-P0qWFmAWH3_7Zw8739",
	API_URL: "https://api.getaddress.io/find/"
};

export {
	siteConfig,
	language,
	themeConfig,
	AlgoliaSearchConfig,
	Auth0Config,
	firebaseConfig,
	googleConfig,
	mapboxConfig,
	youtubeSearchApi,
	instagramConfig,
	jwtConfig,
	apiUrls,
	getaddressConfig,
	stripeKey
};



// WEBPACK FOOTER //
// ./src/settings/index.js